<!--
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
-->

<div class="documentation-viewer">

  <!-- Main Content Area -->
  <main class="document-content">
    <!-- Markdown Content -->
    <app-markdown-renderer
      [content]="markdownContent"
      [loading]="loading"
      [error]="error"
      [baseRoute]="'/api-mesh/docs'"
      [enableToc]="true"
      class="markdown-content">
    </app-markdown-renderer>
  </main>

  <!-- Navigation Footer -->
  <footer *ngIf="content && (hasNavigation('previous') || hasNavigation('next') || hasChildren())"
          class="document-navigation">

    <!-- Previous/Next Navigation -->
    <div class="nav-section prev-next-nav">
      <button *ngIf="hasNavigation('previous')"
              (click)="navigateToPrevious()"
              class="nav-button nav-previous"
              [attr.aria-label]="'Previous: ' + content.navigation.previous?.title">
        <span class="nav-icon">←</span>
        <div class="nav-content">
          <span class="nav-label">Previous</span>
          <span class="nav-title">{{ content.navigation.previous?.title }}</span>
        </div>
      </button>

      <button *ngIf="hasNavigation('next')"
              (click)="navigateToNext()"
              class="nav-button nav-next"
              [attr.aria-label]="'Next: ' + content.navigation.next?.title">
        <div class="nav-content">
          <span class="nav-label">Next</span>
          <span class="nav-title">{{ content.navigation.next?.title }}</span>
        </div>
        <span class="nav-icon">→</span>
      </button>
    </div>

    <!-- Parent Navigation -->
    <div *ngIf="hasNavigation('parent')" class="nav-section parent-nav">
      <button (click)="navigateToParent()"
              class="nav-button nav-parent"
              [attr.aria-label]="'Back to: ' + content.navigation.parent?.title">
        <span class="nav-icon">↑</span>
        <div class="nav-content">
          <span class="nav-label">Back to</span>
          <span class="nav-title">{{ content.navigation.parent?.title }}</span>
        </div>
      </button>
    </div>

    <!-- Children Navigation -->
    <div *ngIf="hasChildren()" class="nav-section children-nav">
      <h3 class="nav-section-title">In this section:</h3>
      <div class="children-grid">
        <button *ngFor="let child of content.navigation.children"
                (click)="navigateToChild(child)"
                class="child-nav-button"
                [attr.aria-label]="'Navigate to: ' + child.title">
          <div class="child-nav-content">
            <span class="child-nav-title">{{ child.title }}</span>
            <span *ngIf="child.description" class="child-nav-description">{{ child.description }}</span>
          </div>
          <span class="child-nav-icon">→</span>
        </button>
      </div>
    </div>
  </footer>

  <!-- Cross References -->
  <aside *ngIf="content?.metadata?.crossReferences?.length" class="cross-references">
    <h3 class="cross-ref-title">Related Topics</h3>
    <ul class="cross-ref-list">
      <li *ngFor="let ref of content?.metadata?.crossReferences" class="cross-ref-item">
        <a (click)="navigateToRoute(ref.route)"
           [attr.aria-label]="'Related: ' + ref.title"
           class="cross-ref-link">
          <span class="cross-ref-link-title">{{ ref.title }}</span>
          <span *ngIf="ref.description" class="cross-ref-link-description">{{ ref.description }}</span>
        </a>
      </li>
    </ul>
  </aside>
</div>
